import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";

import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";

const SignUpEmail = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorShow, setErrorShow] = useState(false);
  const [error, setError] = useState("");

  const validateEmailAllowed = (email) => {
    if (!email || !props.allowedEmails) return false;
    const emailDomain = email.split("@")[1];
    return emailDomain === "iamclearmind.com" && props.allowedEmails.includes(email);
  };

  const validatePassword = (password) => {
    // Basic password validation - you can customize this
    return password && password.length >= 6;
  };

  const signUpWithEmail = () => {
    // Input validation
    if (!email || !password) {
      setErrorShow(true);
      setError("Email and Password are required.");
      return;
    }

    // Password validation
    if (!validatePassword(password)) {
      setErrorShow(true);
      setError("Password must be at least 6 characters long.");
      return;
    }

    // Domain/Email validation
    if (!validateEmailAllowed(email)) {
      setErrorShow(true);
      setError(`Sign-up denied. Email not verified in allowed list.`);
      return;
    }

    const auth = getAuth();
    createUserWithEmailAndPassword(auth, email, password)
      .then((response) => {
        if (response) {
          console.log("Sign-up successful for allowed domain");
          props.setSignUpMethodOpen(false);
          // Add any additional logic here for successful sign-up
        }
      })
      .catch((err) => {
        setErrorShow(true);
        
        // Provide more specific error messages
        switch (err.code) {
          case 'auth/email-already-in-use':
            setError("The email address is already in use by another account.");
            break;
          case 'auth/invalid-email':
            setError("Invalid email format.");
            break;
          case 'auth/operation-not-allowed':
            setError("Email/password accounts are not enabled.");
            break;
          case 'auth/weak-password':
            setError("Password is too weak. Please choose a stronger password.");
            break;
          case 'auth/network-request-failed':
            setError("Network error. Please check your connection and try again.");
            break;
          default:
            setError("An error occurred during sign-up. Please try again.");
        }
      });
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      signUpWithEmail();
    }
  };

  useEffect(() => {
    if (errorShow) {
      setErrorShow(true);
      const toRef = setTimeout(() => {
        setErrorShow(false);
        clearTimeout(toRef);
      }, 8000);
    }
  }, [errorShow]);

  return (
    <div className="max-w-screen-xl w-full relative rounded-lg font-poppins">
      <div className="text-white font-semibold text-center text-2xl w-full py-4">
         SignIn with Email
      </div>
      <button
        onClick={() => props.setSignUpMethodOpen(false)}
        className="h-10 w-10 flex flex-row justify-center items-center rounded-full  text-white absolute -top-28 left-0  m-1 font-bold hover:text-[#07F2C7]  ease-linear duration-150 cursor-pointer"
      >
        <div>
          <IoIosArrowBack size={16} className=" mr-1" />
        </div>
        <div className="hidden md:flex text-base ">Back</div>
      </button>

      

      <div className="">
        <div className={"w-[100%] md:w-[100%] mt-4 text-left py-3"}>
          <input
            type="email"
            className={
              "w-[100%] py-3 bg-white/10 text-gray-100  rounded-[6px] px-3"
            }
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </div>
        <div className={"w-[100%] md:w-[100%] text-left py-3"}>
          <input
            type="password"
            className={
              "w-[100%] py-3 bg-white/10 text-gray-100  rounded-[6px] px-3"
            }
            placeholder="Enter your password (min 6 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </div>
        <div>
          <button
            onClick={signUpWithEmail}
            disabled={!email || !password}
            className={`mt-8 flex flex-row items-center justify-center py-2.5 w-full mb-3 rounded-[8px] bg-[#07F2C7] text-black font-medium hover:bg-[#07F2C7]/90 ease-linear duration-150 disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            Signup with email
          </button>
        </div>
      </div>
      {errorShow === true ? (
        <div className="flex p-2 mt-2">
          <div className="text-[#D1433A] text-base font-bold ml-2 -mt-0.5">
            {error}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SignUpEmail;




























// import React, { useState, useEffect } from "react";
// import { IoIosArrowBack } from "react-icons/io";

// import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";

// const SignUpEmail = (props) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorShow, setErrorShow] = useState(false);
//   const [error, setError] = useState("");

//   const signUpWithEmail = () => {
//     const auth = getAuth();
//     createUserWithEmailAndPassword(auth, email, password)
//       .then((response) => {
//         if (response) {
//           props.setSignUpMethodOpen(false);
//         }
//       })
//       .catch((err) => {
//         setErrorShow(true);
//         setError("The email address is already in use by another account");
//       });
//   };

//   useEffect(() => {
//     if (errorShow) {
//       setErrorShow(true);
//       const toRef = setTimeout(() => {
//         setErrorShow(false);
//         clearTimeout(toRef);
//       }, 8000);
//     }
//   }, [errorShow]);

//   return (
//     <div className="max-w-screen-xl w-full relative rounded-lg font-poppins">
//       <button
//         onClick={() => props.setSignUpMethodOpen(false)}
//         className="h-10 w-10 flex flex-row justify-center items-center rounded-full  text-white absolute top-0 left-0  m-1 font-bold hover:text-[#07F2C7]  ease-linear duration-150 cursor-pointer"
//       >
//         <div>
//           <IoIosArrowBack size={16} className=" mr-1" />
//         </div>
//         <div className="hidden md:flex text-base ">Back</div>
//       </button>

//       <div className="py-8">
//         <div className={"w-[100%] md:w-[100%] mt-4 text-left py-3"}>
//           <input
//             type="email"
//             className={
//               "w-[100%] py-3 bg-white/10 text-gray-100  rounded-[6px] px-3"
//             }
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//         </div>
//         <div className={"w-[100%] md:w-[100%] text-left py-3"}>
//           <input
//             type="password"
//             className={
//               "w-[100%] py-3 bg-white/10 text-gray-100  rounded-[6px] px-3"
//             }
//             placeholder="Enter your password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//         </div>
//         <div>
//           <button
//             onClick={signUpWithEmail}
//             className={`mt-8 flex flex-row items-center justify-center py-2.5 w-full mb-3 rounded-[8px] bg-[#07F2C7] text-black font-medium hover:bg-[#07F2C7]/90 ease-linear duration-150`}
//           >
//             Signup with email
//           </button>
//         </div>
//       </div>
//       {errorShow === true ? (
//         <div className="flex p-2 mt-2">
//           <div className="text-[#D1433A] text-base font-bold ml-2 -mt-0.5">
//             {error}
//           </div>
//         </div>
//       ) : null}
//     </div>
//   );
// };

// export default SignUpEmail;
